import {requests} from "../../../../@WUM/core/RestFullApi/api";
import {userApiType} from "./userApi.interface";

export const user = {
    getUser: (limit: string, search: any): Promise<userApiType[]> =>
        requests.get(`User/All/${limit}/${search}`),
}
